var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Canvas",
    transform: "translate(2872 2714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_svg__delete_svg__path0_fill",
    transform: "translate(-2872 -2714)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_svg__delete_svg__path1_fill",
    transform: "translate(-2863.4 -2706.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_svg__delete_svg__path2_fill",
    transform: "translate(-2865.66 -2706.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "delete_svg__delete_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_svg__delete_svg__path3_fill",
    transform: "translate(-2867.91 -2706.17)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "delete_svg__delete_svg__path0_fill",
    d: "M 1.26875 6.21798L 1.26875 14.697C 1.26875 15.9741 2.34062 17 3.675 17L 10.325 17C 11.6594 17 12.7312 15.9741 12.7312 14.697L 12.7312 6.21798C 13.4312 6.19704 14 5.63177 14 4.96182L 14 3.26601C 14 2.57512 13.4094 2.00985 12.6875 2.00985L 10.1937 2.00985L 10.1937 1.36084C 10.1937 0.607143 9.55937 -7.98644e-08 8.77187 -7.98644e-08L 5.22813 -7.98644e-08C 4.44063 -7.98644e-08 3.80625 0.607143 3.80625 1.36084L 3.80625 2.00985L 1.3125 2.00985C 0.590625 2.00985 0 2.57512 0 3.26601L 0 4.98276C 0 5.65271 0.56875 6.19704 1.26875 6.21798ZM 10.325 15.7648L 3.675 15.7648C 3.0625 15.7648 2.58125 15.3042 2.58125 14.718L 2.58125 6.23892L 11.4187 6.23892L 11.4187 14.718C 11.4187 15.2833 10.9156 15.7648 10.325 15.7648ZM 5.11875 1.36084C 5.11875 1.29803 5.1625 1.25616 5.22813 1.25616L 8.75 1.25616C 8.81563 1.25616 8.85938 1.29803 8.85938 1.36084L 8.85938 2.00985L 5.11875 2.00985L 5.11875 1.36084ZM 1.3125 3.26601L 12.6875 3.26601L 12.6875 4.98276L 1.3125 4.98276L 1.3125 3.26601Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete_svg__delete_svg__path1_fill",
    d: "M 1.3125 0L 0 0L 0 6.1133L 1.3125 6.1133L 1.3125 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete_svg__delete_svg__path2_fill",
    d: "M 1.3125 0L 0 0L 0 6.1133L 1.3125 6.1133L 1.3125 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "delete_svg__delete_svg__path3_fill",
    d: "M 1.3125 0L 0 0L 0 6.1133L 1.3125 6.1133L 1.3125 0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.398bd68468f069023a630c59461f582f.svg";
export { ForwardRef as ReactComponent };